import React, { memo } from 'react';
import Dialog from '@mui/material/Dialog';
import { Box, Typography, Button } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

function ImportantInformationModal({ 
  open, 
  content, 
  buttonTitle, 
  buttonClick, 
  buttonDisabled = false,
  onBackDropClick, 
  onCloseClick, 
  CloseTitle, 
  CloseButton 
}) {
  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          if (onCloseClick) onCloseClick(event);
        }
      }}
      disableEscapeKeyDown
      sx={{
        zIndex: 1300,
        '& .MuiPaper-root': {
          borderRadius: '24px',
          overflow: 'hidden',
          maxWidth: '480px',
          width: '100%',
          boxShadow: '0 25px 50px -12px rgba(3, 13, 57, 0.18)',
          backgroundColor: '#FFFFFF',
          border: '1px solid rgba(226, 232, 240, 0.8)',
        },
        'body.admin-shell & .MuiPaper-root': {
          boxShadow: 'none',
        },
        '& .MuiBackdrop-root': {
          backdropFilter: 'blur(4px)',
          backgroundColor: 'rgba(3, 13, 57, 0.4)',
        }
      }}
    >
      {/* Header Container - Clean White */}
      <Box sx={{
        backgroundColor: '#FFFFFF',
        pt: 4,
        pb: 1,
        px: 4,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        position: 'relative'
      }}>
        <Box sx={{
          width: '56px',
          height: '56px',
          borderRadius: '16px',
          backgroundColor: '#F0F3FF',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mb: 2,
        }}>
          <InfoOutlinedIcon sx={{ fontSize: '32px', color: '#192873' }} />
        </Box>
        <Typography variant="h5" sx={{ 
          fontWeight: 800, 
          fontFamily: 'Inter, sans-serif',
          fontSize: '22px',
          letterSpacing: '-0.02em',
          color: '#192873'
        }}>
          Información Importante
        </Typography>
      </Box>

      {/* Body Content */}
      <Box sx={{ p: 4, pt: 2, textAlign: 'center', backgroundColor: '#FFFFFF' }}>
        <Typography component="div" sx={{ 
          fontSize: '15px', 
          color: '#475569', 
          lineHeight: 1.6,
          fontFamily: 'Roboto, sans-serif',
          mb: 4
        }}>
          {content}
        </Typography>

        {/* Buttons Action Container */}
        <Box sx={{ 
          display: 'flex', 
          gap: 2, 
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: CloseButton ? { xs: 'column-reverse', sm: 'row' } : 'row'
        }}>
          {CloseButton && (
            <Button
              onClick={onCloseClick}
              variant="outlined"
              sx={{
                flex: 1,
                width: '100%',
                py: 1.4,
                borderRadius: '12px',
                borderColor: '#CBD5E1',
                color: '#475569',
                fontWeight: 700,
                fontSize: '14px',
                fontFamily: 'Inter, sans-serif',
                textTransform: 'none',
                '&:hover': {
                  backgroundColor: '#F8FAFC',
                  borderColor: '#94A3B8',
                  color: '#1E293B',
                }
              }}
            >
              {CloseTitle || 'Cancelar'}
            </Button>
          )}

          <Button
            onClick={buttonClick}
            disabled={buttonDisabled}
            variant="contained"
            sx={{
              flex: 1,
              width: '100%',
              py: 1.4,
              borderRadius: '12px',
              backgroundColor: '#192873',
              color: '#FFFFFF',
              fontWeight: 700,
              fontSize: '14px',
              fontFamily: 'Inter, sans-serif',
              textTransform: 'none',
              boxShadow: '0 4px 14px rgba(3, 13, 57, 0.25)',
              '&.Mui-disabled': {
                backgroundColor: '#CBD5E1 !important',
                color: '#94A3B8 !important',
                boxShadow: 'none',
                cursor: 'not-allowed',
              },
              '&:hover': {
                backgroundColor: '#0A1B5C',
                boxShadow: '0 6px 20px rgba(3, 13, 57, 0.35)',
              },
              'body.admin-shell &, body.admin-shell &:hover': {
                boxShadow: 'none',
              }
            }}
          >
            {buttonTitle || 'Confirmar'}
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
}

export default memo(ImportantInformationModal);